<div *ngIf="isLoading">Loading Breach Type List...</div>

<select *ngIf="!isLoading" [compareWith]="byId" class="form-control" name="breachType"
        [(ngModel)]="model.breachType" [required]="required">
  <option *ngFor="let singleBreachType of breachTypes" [ngValue]="singleBreachType">{{ singleBreachType.name
    }}
  </option>
</select>
